export var BillingInvoiceStatus;
(function (BillingInvoiceStatus) {
    /** Invoice generated but not yet posted */
    BillingInvoiceStatus[BillingInvoiceStatus["Draft"] = 0] = "Draft";
    /** Invoice posted and payment sought */
    BillingInvoiceStatus[BillingInvoiceStatus["Posted"] = 1] = "Posted";
    /** Payment initiated but not yet completed */
    BillingInvoiceStatus[BillingInvoiceStatus["PaymentPending"] = 2] = "PaymentPending";
    /** Fully paid for */
    BillingInvoiceStatus[BillingInvoiceStatus["Paid"] = 3] = "Paid";
    /** Partially paid for */
    BillingInvoiceStatus[BillingInvoiceStatus["PartiallyPaid"] = 4] = "PartiallyPaid";
    /** Latest payment attempt failed or was canceled */
    BillingInvoiceStatus[BillingInvoiceStatus["PaymentFailed"] = 10] = "PaymentFailed";
    /** Not fully paid and now overdue */
    BillingInvoiceStatus[BillingInvoiceStatus["Overdue"] = 11] = "Overdue";
    /** Unpaid but we are no longer seeking payment */
    BillingInvoiceStatus[BillingInvoiceStatus["Defaulted"] = 12] = "Defaulted";
    /** Voided by us */
    BillingInvoiceStatus[BillingInvoiceStatus["Voided"] = 13] = "Voided";
})(BillingInvoiceStatus || (BillingInvoiceStatus = {}));
